/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCreatedBy } from './get-cards-transactions-with-purchase-application-unlinked200-response-inner-evidence-list-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors } from './get-cards-transactions-with-purchase-application-unlinked200-response-inner-evidence-list-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer } from './get-cards-transactions-with-purchase-application-unlinked200-response-inner-evidence-list-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUpdatedBy } from './get-cards-transactions-with-purchase-application-unlinked200-response-inner-evidence-list-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUploadedBy } from './get-cards-transactions-with-purchase-application-unlinked200-response-inner-evidence-list-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings } from './get-cards-transactions-with-purchase-application-unlinked200-response-inner-evidence-list-inner-warnings';

/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'paymentType': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'electronicMethod': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'documentSize': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'legalValidity': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'invoiceIssuer': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'errors': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'warnings': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCreatedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'createdBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUpdatedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'updatedBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUploadedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'uploadedBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerPaymentTypeEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerPaymentTypeEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerPaymentTypeEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerElectronicMethodEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerElectronicMethodEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerElectronicMethodEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDocumentSizeEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDocumentSizeEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDocumentSizeEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerLegalValidityEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerLegalValidityEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerLegalValidityEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDpiErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDpiErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDpiErrorEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDetectedDpiErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDetectedDpiErrorEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerColorGradationErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerColorGradationErrorEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerHeightMillisErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerHeightMillisErrorEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWidthMillisErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWidthMillisErrorEnum];


